export const IpaddressDataAction = (data) => {
	return{
	  type: "IP_ADDRESS_DATA",
	  payload: { data}
	}
}